import { render, staticRenderFns } from "./v-gg-info.vue?vue&type=template&id=0bf606d4&"
import script from "./v-gg-info.vue?vue&type=script&lang=js&"
export * from "./v-gg-info.vue?vue&type=script&lang=js&"
import style0 from "./v-gg-info.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports